import React from 'react';
import { ReactComponent as HardwareIcon } from '../../assets/custom/icons/hardware.svg';
import { SmartRoomControllerModel } from '@common/modelDefinition';
import useStore from '@data/state/zustand';
/*
const statusDesc = {
	0: "not configured",
	1: "online",
	2: "fading",
	3: "disconnected"
}
*/

 enum RoomStatus{
 "not configured",
 "online",
 "fading",
 "disconnected",
}

const getRoomSRCStatusIconByLastSeenTimestamp = (lastSeenTimestamp:number) => {
    var status = 0;
    let result = null;
    let lastSeenMilisecondsFromNow = Date.now() - lastSeenTimestamp;
    status = 1;
    if (lastSeenMilisecondsFromNow > 11 * 60 * 1000) {
        status = 2;
    }
    if (lastSeenMilisecondsFromNow > 21 * 60 * 1000) {
        status = 3;
    }
    let srcChipStyleColorClass = null;
    switch (status) {
        case 1:
            srcChipStyleColorClass = 'text-success';
            break;
        case 2:
            srcChipStyleColorClass = 'text-warning';
            break;
        case 3:
            srcChipStyleColorClass = 'text-danger';
            break;
        case 0:
        default:
            srcChipStyleColorClass = null;
            break;
    }

    if (srcChipStyleColorClass) {
        result = <i className={'fa fa-microchip ' + srcChipStyleColorClass} />;
    }
    return result;
};

const getRoomSRCStatusIcon = (deviceId?:string) => {
    if (deviceId === undefined || deviceId === null) {
        console.warn('getRoomSRCStatus: deviceId is undefined');
    }
    let result = null;
    let status = getRoomSRCStatus(deviceId);
    let srcChipStyleColorClass = null;

    switch (status) {
        case 1:
            srcChipStyleColorClass = 'color-success';
            break;
        case 2:
            srcChipStyleColorClass = 'color-warning';
            break;
        case 3:
            srcChipStyleColorClass = 'color-error';
            break;
        case 0:
        default:
            srcChipStyleColorClass = null;
            break;
    }

    if (srcChipStyleColorClass) {
        result = (
            <div className={srcChipStyleColorClass}>
                <HardwareIcon />
            </div>
        );
    }

    return result;
};

const getRoomSRCStatus = (deviceId?:string) => {
    if (deviceId === undefined || deviceId === null) {
        return 0
    }

    var status = 0;
    const smartRoomControllers: SmartRoomControllerModel[] =  useStore.getState().model.SmartRoomController

    let srcInfo = smartRoomControllers?.find((src:any) => {
        return src && src.remoteDeviceId === deviceId;
    });

    if (srcInfo) {
        let lastSeenTimestamp = srcInfo ? srcInfo.lastSeenTimestamp : 0;
        let lastSeenMilisecondsFromNow = Date.now() - lastSeenTimestamp;
        status = 1;

        if (lastSeenMilisecondsFromNow > 11 * 60 * 1000) {
            status = 2;
        }
        if (lastSeenMilisecondsFromNow > 21 * 60 * 1000) {
            status = 3;
        }
    }

    return status;
};

const getSRCStatus = (srcInfo:SmartRoomControllerModel) => {
    let status = 0;

    if (srcInfo) {
        let lastSeenTimestamp = srcInfo ? srcInfo.lastSeenTimestamp : 0;
        let lastSeenMilisecondsFromNow = Date.now() - lastSeenTimestamp;
        status = 1;

        if (lastSeenMilisecondsFromNow > 11 * 60 * 1000) {
            status = 2;
        }
        if (lastSeenMilisecondsFromNow > 21 * 60 * 1000) {
            status = 3;
        }
    }

    return status;
};


const getSRCStatusIcon = (srcInfo:SmartRoomControllerModel) => {
    let result = null;
    let status = getSRCStatus(srcInfo);
    let srcChipStyleColorClass = null;

    switch (status) {
        case 1:
            srcChipStyleColorClass = 'color-success';
            break;
        case 2:
            srcChipStyleColorClass = 'color-warning';
            break;
        case 3:
            srcChipStyleColorClass = 'color-error';
            break;
        case 0:
        default:
            srcChipStyleColorClass = null;
            break;
    }

    if (srcChipStyleColorClass) {
        result = (
            <div className={srcChipStyleColorClass}>
                <HardwareIcon />
            </div>
        );
    }

    return result;
};
const checkIfRoomHasSettings = (remoteDeviceId:string) => {
    if (remoteDeviceId === undefined || remoteDeviceId === null) {
        console.warn('checkIfRoomHasSettings: remoteDeviceId is undefined');
    }

    let result = true;
    const smartRoomControllers: SmartRoomControllerModel[] =  useStore.getState().model.SmartRoomController

    let srcInfo = smartRoomControllers?.find((src:any) => {
        return src && src.remoteDeviceId === remoteDeviceId;
    });
    if (srcInfo) {
        if (srcInfo.srcType === 'SRC_SOS') {
            result = false;
        } else {
            result = true;
        }
    } else {
        result = false;
    }

    return result;
};

export default getRoomSRCStatusIcon;
export { checkIfRoomHasSettings, getRoomSRCStatus, getRoomSRCStatusIconByLastSeenTimestamp, RoomStatus, getSRCStatus, getSRCStatusIcon };
